import { BodyText } from "@/components/ui/Text";
import { formatDate, formatUtcDateTime } from "@/lib/time";
import type { DiagnosticReport } from "@curai/js-fhir-tools";

export const DiagnosticReportDetails = ({
  diagnosticReport,
}: {
  diagnosticReport: DiagnosticReport;
}) => {
  return (
    <div className="grid grid-cols-2 gap-2">
      <div className="flex flex-col">
        <BodyText size="sm" bold>
          File Name
        </BodyText>
        <BodyText size="sm">
          {diagnosticReport.presentedForm?.[0]?.title ||
            diagnosticReport.presentedForm?.[0]?.url?.split("/").pop()}
        </BodyText>
      </div>
      <div className="flex flex-col">
        <BodyText size="sm" bold>
          Report Date
        </BodyText>
        <BodyText size="sm">
          {diagnosticReport.effectiveDateTime
            ? formatDate(formatUtcDateTime(diagnosticReport.effectiveDateTime))
            : "---"}
        </BodyText>
      </div>
      <div className="flex flex-col">
        <BodyText size="sm" bold>
          Report Status
        </BodyText>
        <BodyText size="sm">{diagnosticReport.statusLabel}</BodyText>
      </div>
    </div>
  );
};
